module.exports = __webpack_public_path__ + "static/media/ana.753e95c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/ana.jpg
// module id = 1206
// module chunks = 0